import { Injectable } from '@angular/core';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private readonly _fullHeightSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  readonly fullHeight$ = this._fullHeightSubject
    .asObservable()
    .pipe(shareReplay({ refCount: true }));

  /**
   * Enable or disable the full height of the sidenav container
   *
   * @param value
   */
  setFullHeight(value: boolean): void {
    this._fullHeightSubject.next(value);
  }
}
